Ext.define('SA.CrosstabBodyCellsCache', {
    extend: 'SA.CellsCache',

    createCell({el}) {
        return new SA.CrosstabBodyCell({el});
    }
});